import script from "./BicycleArticle.vue?vue&type=script&lang=ts&setup=true"
export * from "./BicycleArticle.vue?vue&type=script&lang=ts&setup=true"

import "./BicycleArticle.vue?vue&type=style&index=0&id=088e7f62&scoped=true&lang=css"

import exportComponent from "/Users/jnshul/Documents/tagluffa_i_vue3/main_page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-088e7f62"]])

export default __exports__